/**
 * 添加bus stops 数据
 * 
 * @Author: Focci
 * @Date: 2023-12-29 15:34:18
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-29 15:34:18
 */

'use client'

import { useMapState } from '@comp/mapbox'
import { isArray } from 'lodash-es'
import { useEffect } from 'react'

export default function SchoolMapBusStops({
  data = {}
}) {
  const { setBusStops } = useMapState()

  useEffect(() => {
    isArray(data?.bus_stops) && setBusStops(data.bus_stops)
  }, [data, setBusStops])
}
